function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1908(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 31.02,
    height: 18.48,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.08
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 9.24
  }, "\n        Echols\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 18.48,
    width: 31.02,
    height: 22.06,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 29.509999999999998
  }, "\n        Charlton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.54,
    width: 31.02,
    height: 22.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.1514285714285712
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 51.57
  }, "\n        Quitman\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 62.6,
    width: 31.02,
    height: 25.52,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.104
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 75.36
  }, "\n        Baker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 88.11,
    width: 31.02,
    height: 27.18,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.53
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 101.7
  }, "\n        Miller\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 115.3,
    width: 31.02,
    height: 28.85,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.7700000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 129.725
  }, "\n        Heard\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 144.15,
    width: 31.02,
    height: 29.33,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.256153846153846
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 158.815
  }, "\n        Chattahoochee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 173.48,
    width: 31.02,
    height: 30.64,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.377142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 188.79999999999998
  }, "\n        Webster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 204.12,
    width: 31.02,
    height: 36.72,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 222.48000000000002
  }, "\n        McIntosh\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 240.84,
    width: 31.02,
    height: 37.8,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.4314285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 259.74
  }, "\n        Jenkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 278.64,
    width: 31.02,
    height: 38.03,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.755
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 297.655
  }, "\n        Dade\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 316.68,
    width: 31.02,
    height: 40.42,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.102
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 336.89
  }, "\n        Jeff_Davis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 357.09,
    width: 31.02,
    height: 40.54,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 377.35999999999996
  }, "\n        White\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 397.63,
    width: 31.02,
    height: 40.66,
    style: {
      fill: "#000051"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 417.96
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 438.29,
    width: 31.02,
    height: 40.78,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 458.68
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 479.07,
    width: 31.02,
    height: 42.21,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 500.175
  }, "\n        Dawson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 521.27,
    width: 31.02,
    height: 42.21,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 542.375
  }, "\n        Milton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.48,
    width: 31.02,
    height: 44.23,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 585.595
  }, "\n        Clinch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 607.72,
    width: 31.02,
    height: 45.67,
    style: {
      fill: "#00B200"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.8775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 630.5550000000001
  }, "\n        Glascock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 653.38,
    width: 31.02,
    height: 46.62,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.4466666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 15.51,
    y: 676.6899999999999
  }, "\n        Wilkinson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 0,
    width: 36.68,
    height: 39.82,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.113333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 49.36,
    y: 19.91
  }, "\n        Twiggs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 67.7,
    y: 0,
    width: 38.26,
    height: 39.82,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.465714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 86.83,
    y: 19.91
  }, "\n        Lincoln\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 105.96,
    y: 0,
    width: 38.45,
    height: 39.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.492857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 125.185,
    y: 19.91
  }, "\n        Calhoun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 144.4,
    y: 0,
    width: 38.72,
    height: 39.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.744
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 163.76,
    y: 19.91
  }, "\n        Rabun\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.13,
    y: 0,
    width: 38.91,
    height: 39.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.484999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 202.58499999999998,
    y: 19.91
  }, "\n        Camden\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 222.03,
    y: 0,
    width: 39.65,
    height: 39.82,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.608333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 241.855,
    y: 19.91
  }, "\n        Oconee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 261.69,
    y: 0,
    width: 41.42,
    height: 39.82,
    style: {
      fill: "#010144"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.4,
    y: 19.91
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.1,
    y: 0,
    width: 41.51,
    height: 39.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 323.855,
    y: 19.91
  }, "\n        Clay\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 344.61,
    y: 0,
    width: 41.51,
    height: 39.82,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.424444444444444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 365.365,
    y: 19.91
  }, "\n        Effingham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.12,
    y: 0,
    width: 42.53,
    height: 39.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 407.385,
    y: 19.91
  }, "\n        Schley\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 428.65,
    y: 0,
    width: 42.81,
    height: 39.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 450.05499999999995,
    y: 19.91
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 471.46,
    y: 0,
    width: 43.27,
    height: 39.82,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 493.09499999999997,
    y: 19.91
  }, "\n        Campbell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 514.74,
    y: 0,
    width: 44.48,
    height: 39.82,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.688571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.98,
    y: 19.91
  }, "\n        Lumpkin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 559.22,
    y: 0,
    width: 45.41,
    height: 39.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.964
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 581.9250000000001,
    y: 19.91
  }, "\n        Towns\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 604.63,
    y: 0,
    width: 47.36,
    height: 39.82,
    style: {
      fill: "#4CFF4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.9775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 628.31,
    y: 19.91
  }, "\n        McDuffie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 651.99,
    y: 0,
    width: 48.01,
    height: 39.82,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.636666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 675.995,
    y: 19.91
  }, "\n        Pierce\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 39.82,
    width: 44.67,
    height: 43.29,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.215
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 61.465
  }, "\n        Wilcox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 83.12,
    width: 44.67,
    height: 43.46,
    style: {
      fill: "#D4FFD4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.208571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 104.85000000000001
  }, "\n        Douglas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 126.58,
    width: 44.67,
    height: 44.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.3500000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 148.805
  }, "\n        Catoosa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 171.03,
    width: 44.67,
    height: 45.28,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 193.67000000000002
  }, "\n        Turner\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 216.31,
    width: 44.67,
    height: 47.6,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 240.11
  }, "\n        Taylor\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 263.91,
    width: 44.67,
    height: 47.68,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 287.75
  }, "\n        Forsyth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 311.59,
    width: 44.67,
    height: 48.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.934000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 335.59499999999997
  }, "\n        Banks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 359.6,
    width: 44.67,
    height: 48.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.381428571428572
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 383.69
  }, "\n        Clayton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 407.78,
    width: 44.67,
    height: 48.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 431.90999999999997
  }, "\n        Toombs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 456.04,
    width: 44.67,
    height: 48.51,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.4670000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 480.295
  }, "\n        Taliaferro\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 504.55,
    width: 44.67,
    height: 48.59,
    style: {
      fill: "#B2FFB2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 528.845
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 553.15,
    width: 44.67,
    height: 48.68,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 577.49
  }, "\n        Talbot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 601.82,
    width: 44.67,
    height: 49.01,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.934000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 626.325
  }, "\n        Irwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 31.02,
    y: 650.83,
    width: 44.67,
    height: 49.17,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.58375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.355000000000004,
    y: 675.4150000000001
  }, "\n        Stephens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 39.82,
    width: 44.28,
    height: 49.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 97.83,
    y: 64.71000000000001
  }, "\n        Lee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 119.96,
    y: 39.82,
    width: 44.8,
    height: 49.78,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.959999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 142.35999999999999,
    y: 64.71000000000001
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 164.76,
    y: 39.82,
    width: 45.39,
    height: 49.78,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.484285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 187.45499999999998,
    y: 64.71000000000001
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 210.15,
    y: 39.82,
    width: 45.46,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.6825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 232.88,
    y: 64.71000000000001
  }, "\n        Rockdale\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 255.61,
    y: 39.82,
    width: 47.62,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.524
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 279.42,
    y: 64.71000000000001
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 303.23,
    y: 39.82,
    width: 48.36,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.672
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.41,
    y: 64.71000000000001
  }, "\n        Butts\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 351.59,
    y: 39.82,
    width: 48.51,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.93
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 375.84499999999997,
    y: 64.71000000000001
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 400.1,
    y: 39.82,
    width: 48.66,
    height: 49.78,
    style: {
      fill: "#7FFF7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.951428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 424.43,
    y: 64.71000000000001
  }, "\n        Johnson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 448.76,
    y: 39.82,
    width: 48.66,
    height: 49.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.165
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.09,
    y: 64.71000000000001
  }, "\n        Tift\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 497.42,
    y: 39.82,
    width: 50.07,
    height: 49.78,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.978
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 522.455,
    y: 64.71000000000001
  }, "\n        Oglethorpe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 547.49,
    y: 39.82,
    width: 50.44,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.111428571428571
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 572.71,
    y: 64.71000000000001
  }, "\n        Stewart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 597.93,
    y: 39.82,
    width: 50.52,
    height: 49.78,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.956
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 623.1899999999999,
    y: 64.71000000000001
  }, "\n        Macon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 648.44,
    y: 39.82,
    width: 51.56,
    height: 49.78,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.5311111111111115
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 674.22,
    y: 64.71000000000001
  }, "\n        Habersham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 89.6,
    width: 52.88,
    height: 48.61,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.722
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 113.905
  }, "\n        Crisp\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 138.21,
    width: 52.88,
    height: 48.89,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 162.655
  }, "\n        Early\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 187.09,
    width: 52.88,
    height: 48.95,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.992857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 211.565
  }, "\n        Baldwin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 236.05,
    width: 52.88,
    height: 50.14,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.356666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 261.12
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 286.19,
    width: 52.88,
    height: 50.56,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.222857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 311.47
  }, "\n        Terrell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 336.75,
    width: 52.88,
    height: 50.91,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.485
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 362.205
  }, "\n        Harris\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 387.67,
    width: 52.88,
    height: 51.4,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.28
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 413.37
  }, "\n        Jones\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 439.07,
    width: 52.88,
    height: 51.61,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.734444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 464.875
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 490.68,
    width: 52.88,
    height: 51.75,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 516.5550000000001
  }, "\n        Jasper\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 542.44,
    width: 52.88,
    height: 51.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.422857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 568.4200000000001
  }, "\n        Appling\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 594.4,
    width: 52.88,
    height: 52.24,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.804444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 620.52
  }, "\n        Dougherty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 75.69,
    y: 646.64,
    width: 52.88,
    height: 53.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.576
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 102.13,
    y: 673.3199999999999
  }, "\n        Upson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 89.6,
    width: 54.55,
    height: 52,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 155.845,
    y: 115.6
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.11,
    y: 89.6,
    width: 55.4,
    height: 52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 210.81,
    y: 115.6
  }, "\n        Glynn\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 238.51,
    y: 89.6,
    width: 55.61,
    height: 52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 266.315,
    y: 115.6
  }, "\n        Burke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294.13,
    y: 89.6,
    width: 55.61,
    height: 52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.4
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 321.935,
    y: 115.6
  }, "\n        Dodge\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 349.74,
    y: 89.6,
    width: 56.33,
    height: 52,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 377.90500000000003,
    y: 115.6
  }, "\n        Liberty\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 406.07,
    y: 89.6,
    width: 57.53,
    height: 52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 434.835,
    y: 115.6
  }, "\n        Hart\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 463.6,
    y: 89.6,
    width: 58.32,
    height: 52,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 492.76000000000005,
    y: 115.6
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 521.92,
    y: 89.6,
    width: 58.46,
    height: 52,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.428571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 551.15,
    y: 115.6
  }, "\n        Pulaski\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.38,
    y: 89.6,
    width: 59.45,
    height: 52,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.666666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 610.105,
    y: 115.6
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 639.83,
    y: 89.6,
    width: 60.17,
    height: 52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 669.9150000000001,
    y: 115.6
  }, "\n        Colquitt\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 141.6,
    width: 58.97,
    height: 53.3,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 168.25
  }, "\n        Wilkes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 194.9,
    width: 58.97,
    height: 54.37,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.873999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 222.085
  }, "\n        Dooly\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 249.27,
    width: 58.97,
    height: 54.49,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.784285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 276.515
  }, "\n        Telfair\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 88,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 303.76,
    width: 58.97,
    height: 55.24,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.524
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 331.38
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 89,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 359,
    width: 58.97,
    height: 55.56,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 386.78
  }, "\n        Gilmer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 90,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 414.56,
    width: 58.97,
    height: 55.93,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 442.525
  }, "\n        Berrien\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 91,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 470.49,
    width: 58.97,
    height: 56.37,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.04625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 498.675
  }, "\n        Haralson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 92,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 526.87,
    width: 58.97,
    height: 57,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.5
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 555.37
  }, "\n        Murray\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 93,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 583.87,
    width: 58.97,
    height: 58,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.285714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 612.87
  }, "\n        Pickens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 94,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 128.57,
    y: 641.87,
    width: 58.97,
    height: 58.13,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.304285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 158.055,
    y: 670.9350000000001
  }, "\n        Lowndes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 95,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 141.6,
    width: 55.78,
    height: 62.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.156
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 215.43,
    y: 172.92499999999998
  }, "\n        Worth\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 96,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 243.32,
    y: 141.6,
    width: 55.84,
    height: 62.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.306666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 271.24,
    y: 172.92499999999998
  }, "\n        Brooks\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 97,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 299.16,
    y: 141.6,
    width: 56.02,
    height: 62.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.204
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 327.17,
    y: 172.92499999999998
  }, "\n        Grady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 98,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 355.17,
    y: 141.6,
    width: 56.49,
    height: 62.65,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.06125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 383.415,
    y: 172.92499999999998
  }, "\n        Mitchell\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 99,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 411.66,
    y: 141.6,
    width: 57.25,
    height: 62.65,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.15625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 440.285,
    y: 172.92499999999998
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 100,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.91,
    y: 141.6,
    width: 57.37,
    height: 62.65,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.17125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 497.595,
    y: 172.92499999999998
  }, "\n        Ben_Hill\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 101,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 526.29,
    y: 141.6,
    width: 57.43,
    height: 62.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.17875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 555.005,
    y: 172.92499999999998
  }, "\n        Randolph\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 102,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 583.72,
    y: 141.6,
    width: 57.73,
    height: 62.65,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.621666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 612.585,
    y: 172.92499999999998
  }, "\n        Coffee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 103,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 641.45,
    y: 141.6,
    width: 58.55,
    height: 62.65,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.31875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 670.725,
    y: 172.92499999999998
  }, "\n        Spalding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 104,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 204.25,
    width: 61.86,
    height: 60.08,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.013333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 234.29
  }, "\n        Newton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 105,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 264.33,
    width: 61.86,
    height: 60.26,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.065
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 294.46
  }, "\n        Ware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 106,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 324.59,
    width: 61.86,
    height: 60.56,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.056
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 354.87
  }, "\n        Meriwether\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 107,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 385.14,
    width: 61.86,
    height: 61.27,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.211666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 415.775
  }, "\n        Clarke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 108,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 446.42,
    width: 61.86,
    height: 62.65,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.837142857142856
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 477.745
  }, "\n        Houston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 109,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 509.06,
    width: 61.86,
    height: 62.65,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.372
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 540.385
  }, "\n        Troup\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 110,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 571.71,
    width: 61.86,
    height: 63.84,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.31
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 603.63
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 111,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 187.54,
    y: 635.56,
    width: 61.86,
    height: 64.44,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.7325
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 218.47,
    y: 667.78
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 112,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 204.25,
    width: 61.8,
    height: 64.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 15.45
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.3,
    y: 236.505
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 113,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 311.2,
    y: 204.25,
    width: 62.49,
    height: 64.51,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.927142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.445,
    y: 236.505
  }, "\n        Bulloch\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 114,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 373.69,
    y: 204.25,
    width: 63.12,
    height: 64.51,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.52
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 405.25,
    y: 236.505
  }, "\n        Fannin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 115,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 436.81,
    y: 204.25,
    width: 63.75,
    height: 64.51,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.96875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 468.685,
    y: 236.505
  }, "\n        Cherokee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 116,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 500.55,
    y: 204.25,
    width: 65.35,
    height: 64.51,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 533.225,
    y: 236.505
  }, "\n        Elbert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 117,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 565.91,
    y: 204.25,
    width: 65.87,
    height: 64.51,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.215714285714286
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 598.845,
    y: 236.505
  }, "\n        Screven\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 118,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 631.78,
    y: 204.25,
    width: 68.22,
    height: 64.51,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.751666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 665.89,
    y: 236.505
  }, "\n        Gordon\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 119,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 268.76,
    width: 66.93,
    height: 66.36,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.373333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 301.94
  }, "\n        Chattooga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 120,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 335.11,
    width: 66.93,
    height: 68.9,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.36625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 369.56
  }, "\n        Tattnall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 121,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 404.01,
    width: 66.93,
    height: 70.28,
    style: {
      fill: "#002B84"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.155000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 439.15
  }, "\n        Coweta\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 122,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 474.29,
    width: 66.93,
    height: 74.48,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.155000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 511.53000000000003
  }, "\n        Walton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 123,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 548.77,
    width: 66.93,
    height: 75.2,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.561428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 586.37
  }, "\n        De_Kalb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 124,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 249.4,
    y: 623.97,
    width: 66.93,
    height: 76.03,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.6930000000000005
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 282.865,
    y: 661.985
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 125,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 268.76,
    width: 73.47,
    height: 70.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.676666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 353.065,
    y: 303.78999999999996
  }, "\n        Sumter\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 126,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 389.8,
    y: 268.76,
    width: 76.8,
    height: 70.06,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 428.2,
    y: 303.78999999999996
  }, "\n        Decatur\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 127,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 466.6,
    y: 268.76,
    width: 77.22,
    height: 70.06,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.7844444444444445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.21000000000004,
    y: 303.78999999999996
  }, "\n        Whitfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 128,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 543.82,
    y: 268.76,
    width: 78.06,
    height: 70.06,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.008571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.85,
    y: 303.78999999999996
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 129,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 621.88,
    y: 268.76,
    width: 78.12,
    height: 70.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 17.515
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 660.94,
    y: 303.78999999999996
  }, "\n        Polk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 130,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 338.82,
    width: 81.03,
    height: 67.59,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.8975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.84499999999997,
    y: 372.615
  }, "\n        Hall\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 131,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 406.41,
    width: 81.03,
    height: 71.2,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.171428571428573
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.84499999999997,
    y: 442.01000000000005
  }, "\n        Emanuel\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 132,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 477.6,
    width: 81.03,
    height: 72.66,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.84499999999997,
    y: 513.9300000000001
  }, "\n        Bartow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 133,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 550.26,
    width: 81.03,
    height: 74.39,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 18.5975
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.84499999999997,
    y: 587.455
  }, "\n        Cobb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 134,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 316.33,
    y: 624.65,
    width: 81.03,
    height: 75.35,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.41875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 356.84499999999997,
    y: 662.3249999999999
  }, "\n        Gwinnett\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 135,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.36,
    y: 338.82,
    width: 71.04,
    height: 90.01,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.840000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 432.88,
    y: 383.825
  }, "\n        Walker\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 136,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 468.4,
    y: 338.82,
    width: 73.42,
    height: 90.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.48857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 505.10999999999996,
    y: 383.825
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 137,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 541.82,
    y: 338.82,
    width: 74.08,
    height: 90.01,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.346666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 578.86,
    y: 383.825
  }, "\n        Thomas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 138,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 615.9,
    y: 338.82,
    width: 84.1,
    height: 90.01,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 16.82
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 657.9499999999999,
    y: 383.825
  }, "\n        Floyd\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 139,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.36,
    y: 428.82,
    width: 94.42,
    height: 85.85,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 10.73125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.57,
    y: 471.745
  }, "\n        Muscogee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 140,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.36,
    y: 514.67,
    width: 94.42,
    height: 89.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.778571428571428
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.57,
    y: 559.395
  }, "\n        Laurens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 141,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 397.36,
    y: 604.12,
    width: 94.42,
    height: 95.88,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.8025
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 444.57,
    y: 652.06
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 142,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.78,
    y: 428.82,
    width: 75.26,
    height: 126.72,
    style: {
      fill: "#0645B4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 529.41,
    y: 492.18
  }, "\n        Bibb\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 143,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 567.04,
    y: 428.82,
    width: 132.96,
    height: 126.72,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 18.102857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 633.52,
    y: 492.18
  }, "\n        Chatham\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 144,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 491.78,
    y: 555.54,
    width: 208.22,
    height: 144.46,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 24.076666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 595.89,
    y: 627.77
  }, "\n        Fulton\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1908);
export default __webpack_public_path__ + "static/media/1908.28ed87950372d71267d7cc634cefec2e.svg";
export { ForwardRef as ReactComponent };